import { action, global } from '../const';
import { getServerResponse, getPostServerResponse, onException } from '../functions';
import { Platform } from 'react-native'
import { reSignIn } from './Auth';
import { localStorage } from '../functions/AsyncStorage';

export * from './Auth';
export * from './Chat';
export * from './statistics';
export * from './Family';
export * from './Invite';
export * from './notification';
export * from './Main';
export * from './Homework';

// show a loading dialog
export function showLoader() {
    return (dispatch) => dispatch({ type: action.LOADING_DIALOG_TRUE })
}

// hide a loading dialog
export function hideLoader() {
    return (dispatch) => dispatch({ type: action.LOADING_DIALOG_FALSE })
}

export const UpdateRootState = (payload) => {
    return {
        type: action.UPDATE_ROOT_STATE,
        payload
    };
};

export const exceptionHandler = (method, error) => {
    console.log("Method :- ", method)
    console.log("error :- ", error)
}

export const FailurRequest = (data, callback) => {
    if (!data) return;
    return async (dispatch) => {
        if (data.error && data.error === 121) {
            let res = await dispatch(reSignIn())
            if (!res) return false
            return dispatch(callback)
        }
    }
};

export const currentStrangth = () => {

    return async (dispatch, getState) => {
        let { auth, setting } = getState();
        try {
            let levels = setting.progressLevel
            if (levels.length <= 0)
                levels = await dispatch(getProgressLevels())
            let response = await getServerResponse({
                cmd: 'WcnFamily.getStrengthLevel',
                token: auth.userInfo.token,
                user_ids: auth.userInfo.id,
                family_ids: (auth.userInfo.family_id || '')
            })
            if (response.error) return dispatch(FailurRequest(response, currentStrangth()));
            let state = {}
            response.map(item => {
                if (item.kind === 1) {
                    let strength = Number(item.strength)
                    let max = '', min = '';
                    levels.user.map((item) => {
                        let progress = 0
                        if (strength < 100 && strength > 0) {
                            progress = strength;
                            strength = strength - strength;
                        } else if (strength >= 100) {
                            progress = 100;
                            strength = strength - 100;
                        }
                        if (progress === 100) max = item.name
                        else if (min === '') min = item.name
                        return 1
                    })
                    item['maxLevel'] = max;
                    item['minLevel'] = min;
                    state = Object.assign(state, { userStrength: item })
                }
                else if (item.kind === 2) {
                    let strength = Number(item.strength)
                    let max = '', min = '';
                    levels.user.map((item) => {
                        let progress = 0
                        if (strength < 100 && strength > 0) {
                            progress = strength;
                            strength = strength - strength;
                        } else if (strength >= 100) {
                            progress = 100;
                            strength = strength - 100;
                        }
                        if (progress === 100) max = item.name
                        else if (min === '') min = item.name
                    })
                    item['maxLevel'] = max;
                    item['minLevel'] = min;
                    state = Object.assign(state, { familyStrenght: item })
                }
                return;
            })
            localStorage(1, 'currentStrangth', state)
            return dispatch(UpdateRootState(state));
        } catch (error) {
            return dispatch(FailurRequest(error, currentStrangth()));
        }
    };
};

export const getProgressLevels = () => {

    return async (dispatch, getState) => {
        let { auth } = getState();
        try {
            let user = await getServerResponse({ cmd: 'WcnFamily.getAllLevels', token: auth.userInfo.token, type: 0 })
            let family = await getServerResponse({ cmd: 'WcnFamily.getAllLevels', token: auth.userInfo.token, type: 1 })
            let team = await getServerResponse({ cmd: 'WcnFamily.getAllLevels', token: auth.userInfo.token, type: 2 })

            if (user.error || family.error || team.error)
                return dispatch(FailurRequest(user.error || family.error || team.error, getProgressLevels()));

            let progressLevel = { user, family, team }
            dispatch(UpdateRootState({ progressLevel }));
            return progressLevel
        } catch (error) {
            dispatch(FailurRequest(error, getProgressLevels()))
            return null;
        }
    };
};



export const loader = (payload) => {
    return {
        type: action.APP_LOADER,
        payload
    };
};

export const Set_Device_Height = (payload) => {
    return {
        type: action.GET_DEVICE_HEIGHT,
        payload
    };
};




export const getUserTeams = (user_id) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ cmd: "WcnFamily.getUserOrganization", user_id: user_id || userInfo.id, token: userInfo.token })
            dispatch({ type: action.USER_TEAMS, payload: response })
            return response
        } catch (error) {
            onException(error)
            return [];
        }
    }
};


export const getStranth = (user_id, family_id, team) => {

    return async (dispatch, getState) => {
        let { auth, setting } = getState();
        let userInfo = auth.userInfo
        return await new Promise(async (resolve) => {
            try {

                let levels = setting.progressLevel
                if (levels.length <= 0)
                    levels = await dispatch(getProgressLevels());

                let response = await getServerResponse({ cmd: 'WcnFamily.getStrengthLevel', user_ids: (user_id || ''), token: userInfo.token, family_ids: (family_id || ''), team_ids: (team || '') });
                response.map(item => {
                    if (item.kind === 1) {
                        let strength = Number(item.strength)
                        let max = '', min = '';
                        levels.user.map((item) => {
                            let progress = 0
                            if (strength < 100 && strength > 0) {
                                progress = strength;
                                strength = strength - strength;
                            } else if (strength >= 100) {
                                progress = 100;
                                strength = strength - 100;
                            }
                            if (progress === 100) max = item.name
                            else if (min === '') min = item.name
                            return 1
                        })
                        item['maxLevel'] = max;
                        item['minLevel'] = min;
                    }
                    else {
                        let strength = Number(item.strength)
                        let max = '', min = '';
                        levels.user.map((item) => {
                            let progress = 0
                            if (strength < 100 && strength > 0) {
                                progress = strength;
                                strength = strength - strength;
                            } else if (strength >= 100) {
                                progress = 100;
                                strength = strength - 100;
                            }
                            if (progress === 100) max = item.name
                            else if (min === '') min = item.name
                        })
                        item['maxLevel'] = max;
                        item['minLevel'] = min;
                    }
                })
                resolve(response)
            } catch (error) {
                resolve([])
                console.log(error)
            }
        });
    }
};

export const uploadVoice = (data) => {
    return new Promise(async (resolve) => {
        try {
            let response = await getPostServerResponse({ cmd: 'WcOperation.uploadVoice', data, format: global.AUDIOFORMAT })
            resolve(response)
        } catch (error) {
            onException(error)
            resolve(null)
        }
    });

};



// [#222 VersionControl.checkDVVersion]
export const checkDVVersion = () => {

    return async (dispatch) => {
        try {
            let platform = global.APP_PLATFORM();
            if (platform === "and" && !global.IsAndroidStandAlone) platform = "and_gl";
            console.log("checking new version : " + platform + "-" + global.AppVersion);
            const res = await getServerResponse({ cmd: "VersionControl.checkDVVersion", current: global.AppVersion, platform });
            return res;
        } catch (error) {
            console.log("VersionControl.checkDVVersion: ", error);
            return;
        }
    };
};
